import { useLayoutEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import Title from 'src/refactor_components/common/Title';
import Checkbox from 'src/refactor_shared/ui/checkbox';
import { BoxIcon } from '#atoms';

const CurriculumPrice = () => {
  const { control, register } = useFormContext<{
    price: number;
    lectureSessionPackage: Array<{ session: number; price: number | null }>;
  }>();

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'lectureSessionPackage'
  });

  useLayoutEffect(() => {
    fields.map((value, targetIndex) => {
      update(targetIndex, {
        session: (targetIndex + 1) * 10,
        price: value.price
      });
    });
  }, [fields.length]);

  const onDeleteSession = (index: number) => {
    remove(index);
  };

  return (
    <div className="flex flex-col gap-8 items-start">
      <Title essential text="회당 가격" />
      <input
        type="number"
        {...register('price')}
        className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
        placeholder={'가격을 입력해 주세요'}
      />
      <Checkbox
        wrapperClassName="self-end"
        registerName={'isMultiSessionDiscount'}
        labelTitle={'다회차 가격 할인'}
      />
      <div className="w-full flex flex-col gap-10">
        <Title essential text="다회차 가격" />
        {fields.map((value, index) => {
          return (
            <div key={value.id} className="w-full flex flex-col gap-8">
              <p className="text-[14px] text-[#EAE8ED]">
                {value.session}회 이상
              </p>
              <div className="flex items-center gap-10">
                <input
                  {...register(`lectureSessionPackage.${index}.price`)}
                  className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
                  placeholder={'가격을 입력해 주세요'}
                />
                <button
                  type="button"
                  onClick={() => {
                    onDeleteSession(index);
                  }}
                  className="cursor-pointer"
                >
                  <BoxIcon type="wastebasket" onlyIcon size={18} />
                </button>
              </div>
            </div>
          );
        })}
        <button
          type="button"
          className="text-[#9170F2] self-end"
          onClick={() =>
            append({
              session: (fields.length + 1) * 10,
              price: null
            })
          }
        >
          + 회차 추가
        </button>
      </div>
    </div>
  );
};

export default CurriculumPrice;
